import { HttpClient } from '@angular/common/http';
import {
  computed,
  effect,
  inject,
  Injectable,
  Injector,
  signal,
  untracked,
} from '@angular/core';

import { environment } from '../../environments/environment';

import { LngLatLike } from 'mapbox-gl';
import { Observable } from 'rxjs';

export interface AddressPopup {
  position: LngLatLike;
  street: string;
  address: string;
  eopData: any;
}

@Injectable({
  providedIn: 'root',
})
export class MapService {
  private http = inject(HttpClient);
  private injector = inject(Injector);

  activeMapLayer = signal<{
    name: string;
    style: string;
  }>(undefined);

  public mapLayers = [
    {
      name: 'radar',
      style: 'connybruhn/ckcyi11261klk1iqvvrqowu4b',
    },
    {
      name: 'street',
      style: 'connybruhn/ckmb16v2ejg2h17lji448usbr',
    },
    {
      name: 'sat',
      style: 'connybruhn/ckmbuv4ph3bhn17ql98o3b4st',
    },
  ];

  public readonly getActiveMapLayer = computed(() => {
    return this.activeMapLayer() ?? this.mapLayers[0];
  });

  constructor() {
    this.listenToActiveMapLayerChanges();
  }

  private listenToActiveMapLayerChanges() {
    effect(
      () => {
        if (this.activeMapLayer()) {
          return;
        }

        untracked(() => {
          const savedMapLayer = localStorage.getItem('mapLayer');

          const layer =
            this.mapLayers.find(m => m.name === savedMapLayer) ??
            this.mapLayers[0];

          this.activeMapLayer.set(layer);
        });
      },
      { injector: this.injector }
    );
  }

  getAddressOfPosition(pos: LngLatLike): Observable<any> {
    const fullUrl =
      'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      pos[0] +
      ',' +
      pos[1] +
      '.json?types=address&access_token=' +
      environment.mapbox.accessToken;
    return this.http.get(fullUrl);
  }
}
